export * from './lib/image-player.module';
